import { render, staticRenderFns } from "./GoodsType.vue?vue&type=template&id=3bf32924&scoped=true&"
import script from "./GoodsType.vue?vue&type=script&lang=js&"
export * from "./GoodsType.vue?vue&type=script&lang=js&"
import style0 from "./GoodsType.vue?vue&type=style&index=0&id=3bf32924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf32924",
  null
  
)

export default component.exports